import React, { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';
import usePlaybackStore from '../../Store/playbackStore';
import DataStateBadge from '../Common/DataStateBadge';
import LiveBadge from '../Common/LiveBadge';

const WidgetPanelSlotContext = createContext(undefined);
const WidgetPanelStatusContext = createContext(undefined);

export function WidgetPanelSlotProvider({ target, statusTarget, children }) {
  return (
    <WidgetPanelSlotContext.Provider value={target}>
      <WidgetPanelStatusContext.Provider value={statusTarget}>
        {children}
      </WidgetPanelStatusContext.Provider>
    </WidgetPanelSlotContext.Provider>
  );
}

export function WidgetPanelControls({ children, className = '' }) {
  const target = useContext(WidgetPanelSlotContext);
  const controls = (
    <div className={['widget-panel-controls', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );

  if (target === undefined) return controls;
  return target ? createPortal(controls, target) : null;
}

export function WidgetPanelStatus({ children, className = '', hideDuringReplay = false }) {
  const target = useContext(WidgetPanelStatusContext);
  const replaying = usePlaybackStore((state) => state.mode === 'playing');
  if (hideDuringReplay && replaying) return null;

  const status = (
    <div className={['widget-panel-status', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );

  if (target === undefined) return status;
  return target ? createPortal(status, target) : null;
}

export function WidgetPanelDataStatus({ status, asOf }) {
  if (!['live', 'stale', 'closed'].includes(status)) return null;
  return (
    <WidgetPanelStatus hideDuringReplay>
      <DataStateBadge status={status} asOf={asOf} compact />
    </WidgetPanelStatus>
  );
}

export function WidgetPanelLiveStatus({ dot = false }) {
  return (
    <WidgetPanelStatus hideDuringReplay>
      <LiveBadge dot={dot} />
    </WidgetPanelStatus>
  );
}
